import React from 'react';
import config from 'modules/emergencies/components/log/logConfig';

export const TitleLog = ({ titleData }) => {
  const configValues = config(titleData.config);
  const TitleComponent = configValues[titleData.log.verb]?.render;
  return TitleComponent ? TitleComponent({ titleData }) : <></>;
};
